import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  success: false,
  loading: false,
  loaded: false,
  orders: [],
  error: {},

  saleReports: [],
  saleReportLoading: false,

  refundOrders: {},
  refundOrderLoading: false,

  promoCodeOrders: [],
  promoCodeOrderLoading: false,

  promotionExpense: null,
  promotionExpenseLoading: false,

  merchantCategories: {},
  merchantCategoryError: {},
  merchantCategoryLoaded: false,
  merchantCategoryLoading: false,
})

const { Types, Creators } = createActions({
  fetchOrders: ['merchantKey', 'startFrom', 'endAt', 'extraFields'],
  fetchOrdersSuccess: ['orders'],
  fetchOrdersError: ['error'],

  getSaleReports: ['startFrom', 'endAt'],
  setSaleReports: ['data'],
  setSaleReportLoading: ['val'],

  getRefundOrders: ['startFrom', 'endAt', 'refunded'],
  setRefundOrders: ['data'],
  setRefundOrderLoading: ['val'],

  getPromoCodeOrders: ['startFrom', 'endAt'],
  setPromoCodeOrders: ['data'],
  setPromoCodeOrderLoading: ['val'],

  getPromotionExpense: ['startFrom', 'endAt'],
  setPromotionExpense: ['data'],
  setPromotionExpenseLoading: ['val'],

  getMerchantCategories: null,
  setMerchantCategories: ['data'],
  setMerchantCategoryError: ['err'],

  setSingleRefundOrder: ['payload']
})

export const getMerchantCategoriesReducer = state => state.set('loading', true)
export const setMerchantCategoriesReducer = (state, { data }) => {
  return state
    .set('merchantCategoryLoading', false)
    .set('merchantCategoryLoaded', true)
    .set('merchantCategories', data)
}
export const setMerchantCategoryErrorReducer = (state, { err }) => {
  return state
    .set('merchantCategoryLoading', false)
    .set('merchantCategoryLoaded', false)
    .set('merchantCategoryError', err)
}

export const fetchOrdersRequestReducer = state => state.set('loading', true)

export const fetchOrdersSuccessReducer = (state, { orders }) => {
  return state
    .set('loading', false)
    .set('loaded', true)
    .set('success', true)
    .set('orders', orders)
}

export const fetchOrdersErrorReducer = (state, { error }) =>
  state
    .set('error', error)
    .set('success', false)
    .set('loading', false)

export const setSaleReportsReducer = (state, { data }) =>
  state.set('saleReports', data).set('saleReportLoading', false)
export const setSaleReportLoadingReducer = (state, { val }) => state.set('saleReportLoading', val)

export const setRefundOrdersReducer = (state, { data }) =>
  state.set('refundOrders', data).set('refundOrderLoading', false)
export const setRefundOrderLoadingReducer = (state, { val }) => state.set('refundOrderLoading', val)

export const setPromoCodeOrdersReducer = (state, { data }) =>
  state.set('promoCodeOrders', data).set('promoCodeOrderLoading', false)
export const setPromoCodeOrderLoadingReducer = (state, { val }) => state.set('promoCodeOrderLoading', val)

export const setPromotionExpenseReducer = (state, { data }) =>
  state.set('promotionExpense', data).set('promotionExpenseLoading', false)
export const setPromotionExpenseLoadingReducer = (state, { val }) => state.set('promotionExpenseLoading', val)

export const setSingleRefundOrderReducer = (state, { payload }) => state.setIn(['refundOrders', payload.data.firebase_key], payload.data)

export const hasuraOrderReducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_ORDERS]: fetchOrdersRequestReducer,
  [Types.FETCH_ORDERS_SUCCESS]: fetchOrdersSuccessReducer,
  [Types.FETCH_ORDERS_ERROR]: fetchOrdersErrorReducer,

  [Types.SET_SALE_REPORTS]: setSaleReportsReducer,
  [Types.SET_SALE_REPORT_LOADING]: setSaleReportLoadingReducer,

  [Types.SET_REFUND_ORDERS]: setRefundOrdersReducer,
  [Types.SET_REFUND_ORDER_LOADING]: setRefundOrderLoadingReducer,
  [Types.SET_SINGLE_REFUND_ORDER]: setSingleRefundOrderReducer,

  [Types.SET_PROMO_CODE_ORDERS]: setPromoCodeOrdersReducer,
  [Types.SET_PROMO_CODE_ORDER_LOADING]: setPromoCodeOrderLoadingReducer,

  [Types.SET_PROMOTION_EXPENSE]: setPromotionExpenseReducer,
  [Types.SET_PROMOTION_EXPENSE_LOADING]: setPromotionExpenseLoadingReducer,

  [Types.SET_MERCHANT_CATEGORIES]: setMerchantCategoriesReducer,
  [Types.SET_MERCHANT_CATEGORY_ERROR]: setMerchantCategoryErrorReducer,
})

export const HasuraOrderTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/hasuraOrderReducer.js